import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'cityads-v3/types/reducer';

import {
  toggleMenu,
} from 'cityads-v3/actions/menu';

import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon';

import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined'
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';

import MenuItem from './MenuItem';
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip';

export default function MenuContentUser(): JSX.Element {
  const dispatch = useDispatch()
  const docked = useSelector((state: RootState) => state.menu.docked)
  const isMobile = useSelector((state: RootState) => state.app.isMobile)
  const menu = useSelector((state: RootState) => state.menu.menu)

  const onToggleMenu = useCallback((open: boolean, docked = false) => () => {
    dispatch(toggleMenu(open, docked));
  }, [dispatch])

  useEffect(() => {
    if (isMobile) {
      onToggleMenu(false, false)();
    }
  }, [isMobile, onToggleMenu])

  return (
    <List>

      {!isMobile && <ListItem sx={{ p: 0 }}>
        <ListItemButton
          onClick={onToggleMenu(true, !docked)}
        >
          <ListItemIcon
            sx={{
              margin: !docked && !isMobile ? 'auto' : '0',
              minWidth: 'initial',
              marginRight: docked && !isMobile ? '0.75em' : 'auto',
            }}
          >
            {docked ? <KeyboardArrowLeftOutlinedIcon /> : <KeyboardArrowRightOutlinedIcon />}
          </ListItemIcon>
        </ListItemButton>
      </ListItem>}

      {menu.map(item => {
        const listItem = <MenuItem key={item.n} {...item} />;

        return docked ? listItem : (
          <Tooltip
            key={item.n}
            isLight
            title={item.t}
            placement="right"
          >
            {listItem}
          </Tooltip>
        );
      })}

    </List>
  );
}
